var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3336 3.5026C8.3336 4.23898 7.7366 4.83594 7.00027 4.83594C6.26387 4.83594 5.66693 4.23898 5.66693 3.5026C5.66693 2.76622 6.26387 2.16927 7.00027 2.16927C7.7366 2.16927 8.3336 2.76622 8.3336 3.5026ZM9.31014 4.83594C9.53707 4.4437 9.66694 3.98832 9.66694 3.5026C9.66694 2.02984 8.473 0.835938 7.00027 0.835938C5.52748 0.835938 4.33357 2.02984 4.33357 3.5026C4.33357 3.98832 4.46344 4.4437 4.69033 4.83594H2.37744C2.05259 4.83594 1.77504 5.07007 1.7203 5.39027L0.466735 12.7236C0.397135 13.1308 0.710788 13.5026 1.12388 13.5026H12.8766C13.2897 13.5026 13.6033 13.1308 13.5337 12.7236L12.2802 5.39027C12.2255 5.07007 11.9479 4.83594 11.6231 4.83594H9.31014ZM7.00027 6.16927H11.0607L12.0863 12.1693H1.91417L2.93981 6.16927H7.00027Z",
    fill: "#416EB2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinWeight);
export default __webpack_public_path__ + "static/media/min-weight.c05589788f22c8ff47697450dc7ee2ef.svg";
export { ForwardRef as ReactComponent };